/**
 * Encryption for Base64
 */


const useValidatePhone  = (rule, value, callback) => {
    const regex = /^1[3-9]\d{9}$/;
    if (!regex.test(value)) {
        callback(new Error('请输入格式正确的手机号码'));
    } else {
        callback();
    }
};

export default useValidatePhone ;
